<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-10">
    <h2>Dado Adicional - Modelo</h2>
    <h3>Admin</h3>
  </div>
  <div class="col-lg-2"></div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content">
          <div class="info-page">
            <h3>{{ actionLabel }}</h3>
          </div>

          <form [formGroup]="form" (ngSubmit)="salvar()">
            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">Nome</label>
                <input type="text" id="title" class="form-control" formControlName="title" required maxlength="255" />
                <app-field-message [field]="fieldMessageRequired('title') || _erros?.title" [textErroServer]="_erros?.title" [erros]="fieldErros('title')"></app-field-message>
              </div>
            </div>

            <div formArrayName="processagencytarget">
              <div class="form-group row m-b" *ngFor="let item of getFormArray().controls; let i = index">
                <div class="col-sm-4">
                  <label class="col-sm-12 pb-1">Órgão disponível</label>
                  <ng-select id="orgao" class="ng-select-alternative" [items]="list?.orgaos" bindLabel="str_nome" bindValue="num_codigo_pk" placeholder="Selecione o Órgão" [formControlName]="i">
                  </ng-select>
                </div>
                
                <button class="btn btn-primary col-sm-1 btn-remove font-icon" type="button" (click)="removeOrgao(i)">delete</button>
              </div>
              <button class="btn btn-success btn-add-item" type="button" (click)="addNewOrgao()">Novo Órgão Alvo</button>
            </div>

            <div class="form-group row m-b m-t-mdx">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">Campos</label>
                <ng-select id="question" class="ng-select-alternative" [items]="list?.question" bindLabel="label" formControlName="questionItem" placeholder="Selecione a Questão">
                </ng-select>
              </div>
              <button class="btn btn-success col-sm-4 btn-add-question" type="button" (click)="addNewQuestion()">Nova Questão</button>
            </div>

            <div *ngIf="questionListTable?.length" class="table-width">
              <div class="info-page">
                <h3>Lista de Campos</h3>
              </div>

              <div class="system-table table-container">
                <div class="system-table-conteiner">
                  <table cdkDropList (cdkDropListDropped)="drop($event)" class="ordenacao">
                    <thead>
                      <tr>
                        <th>Ordem</th>
                        <th>Campo</th>
                        <th>Permite Branco</th>
                        <th class="text-center btn-icon-td">Ações</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let question of questionListTable let i = index" cdkDrag>
                        <td class="title">{{i + 1}}</td>
                        <td>{{ question?.label }}</td>
                        <td>
                          <div class="switch">
                            <div class="onoffswitch">
                              <input type="checkbox" (change)="question.allow = !question.allow" [checked]="question.allow" class="onoffswitch-checkbox" id="{{i}}">
                              <label class="onoffswitch-label" for="{{i}}">
                                <span class="onoffswitch-inner switchSimNao"></span>
                                <span class="onoffswitch-switch"></span>
                              </label>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="btn-icon">
                            <span class="icon-table font-icon" (click)="removeQuestion(i)">
                              delete
                            </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="hr-line-dashed"></div>
            <div class="form-group row d-flex justify-content-end">
              <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
                <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
                <button *ngIf="entity?.id" class="btn btn-success m-r-xs" type="button" (click)="openModalClonar()">Clonar</button>
                <button class="btn btn-primary" type="submit">Salvar</button>
              </div>
            </div>
          </form>
          <br>
          <app-historico-atualizacoes-list [audit]="audit"></app-historico-atualizacoes-list>
        </div>
      </div>
    </div>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>